export default __webpack_public_path__ + "static/media/green_tubes.f63af761.webp";